import React, { forwardRef } from 'react';
import styles from './VoucherInput.module.css';

// Images
import voucher_icon from '/voucher.svg'

const VoucherInput = forwardRef((props, ref) => {
  return (
    <div className={styles.inputContainer}>
      <span className={styles.icon}><img src={voucher_icon} alt='voucher_icon' /></span>
      <input
        type="text"
        placeholder="Введите код ваучера"
        className={styles.input}
        ref={ref}
      />
    </div>
  );
});

export default VoucherInput; 